const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const sportslists = (state = initialState, action) => {
	switch (action.type) {
		case 'SBL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SBL_DEL_DATA':
			const data = state.data.filter((e) => e.id !== action.index)
			return { ...state, data, total: state.total - 1 }
		case 'SBL_ADD_DATA':
			const addDatas = [...state.data, action.data]
			return Object.assign({ ...state, data: addDatas, total: state.total + 1 })
		case 'SBL_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const upateData = state.data
			upateData[index] = action.data
			return Object.assign({ ...state, data: [...upateData] })
		case 'SBL_GET_CURRENT':
			return { ...state, selected: action.selected }
		case 'SBL_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default sportslists
